import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import admindata from "../../components/admindata";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { apiRequest } from "../../apiServices/allApi";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const DepositManual = () => {
  const history = useHistory();
  const [user, setUser] = useState();
  const [allDeposite, SetallDeposite] = useState();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const id = localStorage.getItem("id");

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");
  const [refId, setRefId] = useState(0);
  const [findByStatus, setFindByStatus] = useState("Pending");
  const [amount, setAmount] = useState(0);
  const [searchList1, setSearchList1] = useState(0);
  const [reason, setReason] = useState(0);
  const [utr, setUtr] = useState(0);

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;

    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    setSearchType("0");
    let key = event.target.value;
    // setFindByStatus(key)
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };
  const searchHandler1 = (event) => {
    let key = event.target.value;
    setSearchList1(key);
  };

  const amountAdd = (event) => {
    let key = event.target.value;
    setAmount(key);
  };
  const reasonToAdd = (event) => {
    let key = event.target.value;
    setReason(key);
  };
  const utrToAdd = (event) => {
    let key = event.target.value;
    setUtr(key);
  };

  const fetchData = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/txn/get_deposit/allmanual?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
        "GET",
        null,
        headers,
      );
      setUser(res.data.admin);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
      // console.log(error.message);
    } finally {
      // setLoading(false)
    }
  };

  const checkdeposit = async (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `depositupipay/response`,
        { order_id, order_token, pay_date },
        "POST",
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const cash_free_deposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `deposit/response`,
        "POST",
        { order_id, order_token },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const phone_deposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `phonpay-request-status?txnId=${order_id}`,
        "GET",
        null,
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const universalCheckDeposit = (
    payment_gatway,
    order_id,
    order_token,
    pay_date,
  ) => {
    //alert(payment_gatway);
    if (window.confirm("Are you sure you want to proceed with this payment?")) {
      if (payment_gatway == "razorpay") {
        checkrazorpayPayment(order_id, order_token, pay_date);
      } else if (payment_gatway == "haodapay") {
        haodapay(order_id, order_token, pay_date);
      } else if (payment_gatway == "pinelab") {
        checkPinelabpay(order_id, order_token, pay_date);
      } else if (payment_gatway == "upigateway") {
        checkupigatewaypay(order_id, order_token, pay_date);
      } else if (payment_gatway == "phonepe") {
        checkupigatewayphonepe(order_id, order_token, pay_date);
      } else if (payment_gatway == "paymanual") {
        checkupigatewaypaymanual(order_id, order_token, pay_date, "SUCCESS");
      } else if (!payment_gatway) {
        withdrowFail(order_id);
      } else {
        alert("Nothing found");
      }
    }
  };

  const depositAdd = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const datas = {
      Phone: searchList1,
      amount: amount,
      reason: reason,
      UTR: utr,
    };
    try {
      const res = await apiRequest(
        `dipositupdate/whatsapp`,
        "POST",
        datas,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: "Oops...",
          text: res.data.message,
          icon: "error",
        });
        // window.location.reload()
      } else {
        Swal.fire({
          title: "deposit success",
          text: res.data.message,
          icon: "success",
        });
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        title: "Oops...",
        text: e.message,
        icon: "error",
      });
      if (e.data.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const checkrazorpayPayment = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `razorpaycheck/response`,
        { order_id, order_token },
        "POST",
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const haodapay = async (order_id, order_token, pay_date) => {
    alert(order_id);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `haodapay-request-status?txnId=` + order_id,
        "GET",
        null,
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const checkupigatewaypay = async (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `depositupipay/response`,
        { order_id, order_token },
        "POST",
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const checkupigatewayphonepe = async (
    order_id,
    order_token,
    pay_date,
    msg = null,
  ) => {
    alert(order_id);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `phonpay-request-status?txnId=${order_id}`,
        "GET",
        null,
        headers,
      );
      // console.log(res.data, 'res.data')
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const checkupigatewaypaymanual = async (
    order_id,
    order_token,
    pay_date,
    status,
  ) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `userdipositupdate/${order_id}`,
        "POST",
        { status, status },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const PaymanualReject = async (order_id) => {
    const { value: manualPaymentInput } = await Swal.fire({
      title: "Enter Reject Payment Details",
      input: "text",
      inputPlaceholder: "Enter Reject Msg here",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Payment details cannot be empty!";
        }
      },
    });

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `userdipositupdate/${order_id}`,
        "POST",
        { status: "FAILED", msg: manualPaymentInput },
        headers,
      );

      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        // localStorage.removeItem('token');
        // localStorage.removeItem('token');
        // window.location.reload()
      }
    } finally {
      // setLoading(false)
    }
  };

  const checkPinelabpay = async (order_id, order_token, pay_date) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `pinelabdesposit/response`,
        { order_id, order_token },
        "POST",
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
      // setLoading(false)
    }
  };

  const withdrowFail = async (id) => {
    const confirm = window.confirm(
      "Are you sure, you want to update to failed this deposit?",
    );
    if (confirm) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      try {
        const res = await apiRequest(
          `userdipositupdate/${id}`,
          { status: "FAILED" },
          "POST",
          headers,
        );
        fetchData();
        alert("deposit successfully reject");
      } catch (e) {
        //console.log(e);
      } finally {
        // setLoading(false)
      }
    }
  };

  // edit payment

  const EditPayment = (amount, txnId) => {
    const access_token = localStorage.getItem("token");

    Swal.fire({
      title: "Submit your Payment details",
      input: "number",
      inputValue: amount,
      inputAttributes: {
        autocapitalize: "on",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        const requestData = {
          amount: login,
          txnId: txnId,
        };
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`, // Set the appropriate content type
        };

        try {
          const res = apiRequest(
            "admin/bonus_edit_users",
            "POST",
            requestData,
            headers,
          );
          fetchData();
          if (!res.status == "ok") {
            throw new Error(res.statusText);
          }
          // return res.json()
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    // finally {
    //   // setLoading(false)
    // }
  };

  // check in

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const newdateFormat = (e) => {
    let today = new Date(e);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();
    today = dd + "-" + mm + "-" + yyyy;
    return today;
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  if (user == undefined) {
    return null;
  }

  const Invoice = (data) => {
    const userData = { data };
    // setUser(userData);
    console.log(userData);
    history.push("/invoice", { userData });
  };

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row mt-5">
        <div className="col-12 grid-margin">
          <div className="card ">
            <div className="card-body text-light table_bg">
              <div className="row">
                <input
                  type="number"
                  placeholder="Phone..."
                  className="form-control col-sm-3 m-2"
                  onChange={searchHandler1}
                  required
                />
                <input
                  type="number"
                  placeholder="Amount..."
                  className="form-control col-sm-3 m-2"
                  onChange={amountAdd}
                  required
                />
                <input
                  type="text"
                  placeholder="Reason..."
                  className="form-control col-sm-2 m-2"
                  onChange={reasonToAdd}
                  required
                />
                <input
                  type="number"
                  placeholder="Utr..."
                  className="form-control col-sm-2 m-2"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length >= 6) {
                      utrToAdd(e);
                    }
                  }}
                  required
                />
                <button className="btn btn-primary" onClick={depositAdd}>
                  {" "}
                  Add payment{" "}
                </button>
              </div>
              <h4 className="dashboard_heading">Deposit Manual</h4>

              {/* searching */}
              <div className="row">
                {/* <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                                      <option value='Phone'>Phone</option>

                  <option value='Name'>Name</option>
                  <option value='Phone'>Phone</option>
                  <option value='_id'>TxnId</option>
                  <option value='RefId'>RefId</option>
                </select> */}
                <select
                  className="form-control col-sm-3 m-2"
                  id="findByStatus"
                  name="findByStatus"
                  value={findByStatus}
                  onChange={searchByStatus}
                >
                  <option value="Pending">Pending</option>
                </select>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control col-sm-4 m-2"
                  onChange={searchHandler}
                />
                <h5>Or</h5>
                <select
                  className="form-control col-sm-3 m-2"
                  id="findByStatus"
                  name="findByStatus"
                  onChange={searchByStatus}
                >
                  <option value="0">Search Status</option>
                  <option value="FAILED">FAILED</option>
                  <option value="Pending">Pending</option>
                  {/* <option value='pending'>pending</option> */}
                  <option value="PAID">PAID</option>
                  {/* <option value='pending'>pending</option> */}
                  <option value="checkin">Checkin</option>
                </select>
                <select
                  className="form-control col-sm-1 m-1 bg-dark text-light"
                  id="pagelimit"
                  name="pagelimit"
                  onChange={setpageLimit}
                >
                  <option value="10">Set limit</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                </select>
              </div>

              <div className="table-responsive">
                <table className="table text-light">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> Phone</th>
                      <th> User</th>
                      <th> UTR</th>
                      <th> ScreenShot</th>
                      <th> Amount </th>
                      <th> ----- </th>
                      <th> Action </th>
                      <th> Action By</th>
                      <th> Status </th>
                      <th> Date </th>
                      <th> deposit_reason</th>
                      {id == "6931311e30989ed52eebce14" ? (
                        <th>ORDER ID</th>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user
                        .filter(
                          (data) =>
                            data?.status?.toUpperCase() !== "PAID" &&
                            data?.status?.toUpperCase() !== "FAILED",
                        )
                        .map((data, key) => {
                          // console.log(data.order_id)
                          var id = data._id.toString(),
                            ctr = 0;
                          var timestamp = id.slice(ctr, (ctr += 8));
                          var machineID = id.slice(ctr, (ctr += 6));
                          var processID = id.slice(ctr, (ctr += 4));
                          var counter = id.slice(ctr, (ctr += 6));
                          var counterid = parseInt(timestamp, 16);
                          let currentTime = Date.now();
                          let gameCreatedAt = new Date(
                            data.createdAt,
                          ).getTime();

                          return (
                            <tr>
                              <td>{key + 1}</td>

                              <td>
                                {admindata?.user?.usertype == "Admin" ||
                                admindata?.user?.updateLegalData === true ? (
                                  <span className="pl-2">
                                    {data.User_id ? data.User_id.Phone : ""}
                                  </span>
                                ) : (
                                  <span className="pl-2">{`${
                                    "********" +
                                    data.User_id.Phone.toString().slice(-2)
                                  }`}</span>
                                )}
                              </td>
                              <td>
                                {data.User_id && (
                                  <Link
                                    className="btn btn-sm btn-outline-info"
                                    to={`/user/view_user/${data.User_id._id}`}
                                  >
                                    {data.User_id?.Red_zone == true ? (
                                      <span className="text-danger">
                                        {data.User_id.Name}
                                      </span>
                                    ) : (
                                      <span>{data.User_id.Name}</span>
                                    )}
                                  </Link>
                                )}
                              </td>

                              <td>
                                <span style={{ color: "blue" }}>
                                  {data.order_token}
                                </span>
                              </td>

                              <td>
                                <a
                                  href={`${baseUrl}/${data?.paymentImage}`}
                                  target="_blank"
                                >
                                  <img
                                    alt=""
                                    src={baseUrl + `/${data?.paymentImage}`}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";
                                    }}
                                    className=""
                                    height={600}
                                  />
                                </a>
                              </td>
                              <td>{data.amount}</td>

                              <td>
                                {
                                  //&& (parseInt(gameCreatedAt) + 7200000) < currentTime
                                  data.status != "PAID" &&
                                  data.status != "FAILED" ? (
                                    <button
                                      className="btn btn-danger"
                                      onClick={() =>
                                        universalCheckDeposit(
                                          data.payment_gatway,
                                          data.order_id,
                                          data._id,
                                          data.order_token,
                                          newdateFormat(data.createdAt),
                                        )
                                      }
                                    >
                                      Approve
                                    </button>
                                  ) : (
                                    "Checked All"
                                  )
                                }

                                {
                                  //   <button className="ml-1 btn btn-sm btn-warning" onClick={() => withdrowPass(data._id)}>Success</button>
                                }
                              </td>

                              <td>
                                <button
                                  className="btn btn-primary mr-2"
                                  onClick={() => Invoice(data)}
                                >
                                  View
                                </button>
                                {data.status != "FAILED" &&
                                  data.status != "PAID" && (
                                    <>
                                      <button
                                        className="btn btn-danger mr-2"
                                        onClick={() =>
                                          PaymanualReject(data.order_id)
                                        }
                                      >
                                        reject
                                      </button>
                                      <button
                                        className="btn btn-danger mr-2"
                                        onClick={() =>
                                          EditPayment(data.amount, data._id)
                                        }
                                      >
                                        Edit
                                      </button>
                                    </>
                                  )}
                              </td>
                              <td className="font-weight-bold text-success">
                                {data?.action_by?.Name ?? "----"}
                              </td>
                              <td className="font-weight-bold text-success">
                                {data.status}
                              </td>
                              <td>
                                {dateFormat(data.createdAt).split(",")[0]}{" "}
                              </td>
                              <td>
                                <span style={{ color: "blue" }}>
                                  {" "}
                                  {data.txn_msg.length > 15
                                    ? data.txn_msg.substring(0, 20) + "..."
                                    : data.txn_msg}
                                </span>
                              </td>
                              {id == "6931311e30989ed52eebce14" ? (
                                <td
                                  style={{
                                    color:
                                      data.payment_gatway === "phonepe"
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {data.payment_gatway === "phonepe" ? (
                                    <span>
                                      {data.payment_gatway}-{data._id}
                                      <br />
                                      Order ID: {data?.order_id}
                                    </span>
                                  ) : (
                                    data._id
                                  )}
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositManual;
